import { computed } from 'mobx';

import createContext from 'bz-utilities/hooks/context-v2';
import CacheStore from 'bz-utilities/modules/stores/cached-map-store';

import type { IFSItem } from 'bz-core-controls/hooks-form/controls/field-select';
import type { LocationResponse } from 'tm3-core/api.dtos';
import ELocationStatus from 'tm3-core/interfaces/location/enums/status';

export const [LocationsStoreCtx, useLocationsStore] =
  createContext<LocationsStore>('LocationsStore');

class LocationsStore extends CacheStore<LocationResponse> {
  constructor() {
    super('locations');
  }

  public search(searchTerm: string = ''): LocationResponse[] {
    if (!searchTerm) return this.CurrentLocations;
    const lowerSearchTerm = searchTerm.toLowerCase();
    return this.CurrentLocations.filter(
      (location) =>
        location?.name?.toLowerCase().includes(lowerSearchTerm) ||
        location?.addressLine1?.toLowerCase().includes(lowerSearchTerm) ||
        location?.addressline2?.toLowerCase().includes(lowerSearchTerm) ||
        location?.addressline5?.toLowerCase().includes(lowerSearchTerm)
    );
  }

  @computed
  get CurrentLocations(): LocationResponse[] {
    const live = ELocationStatus.Live.toString();
    return this.All.filter((x) => x.status === live); // not sure why this is a string
  }

  @computed
  get CurrentLocationForDropdown(): IFSItem[] {
    return this.CurrentLocations.map((c) => ({ text: c.name, payload: c.id }));
  }

  @computed
  get CurrentLocationForOnlineDropdown(): IFSItem[] {
    return this.CurrentLocations.map((c) => ({ text: c.name, payload: c.onlineGuid }));
  }
}

export default LocationsStore;
